import React, { forwardRef } from 'react';
import { Input, InputProps } from '@heroui/react';
import { CharCounter } from '../CharCounter';
import styles from './CustomInput.module.scss';

interface CustomInputProps extends Omit<InputProps, 'value'> {
  className?: string;
  isRequired?: boolean;
  label?: string;
  labelPlacement?: 'outside' | 'outside-left' | 'inside';
  placeholder?: string;
  errorMessage?: string;
  showError?: boolean;
  type?: string;
  startContent?: React.ReactNode;
  endContent?: React.ReactNode;
  value?: string | null;
  maxChars?: number;
  minChars?: number;
}

export const CustomInput = forwardRef<HTMLInputElement, CustomInputProps>(
  (
    { className, errorMessage, showError = false, value, maxChars, minChars, ...otherProps },
    ref,
  ) => {
    const isInvalid = !!errorMessage;
    const classnamesInput = {
      inputWrapper: [styles.inputWrapper, className, isInvalid ? 'error' : ''],
      label: [styles.label, isInvalid ? 'error' : ''],
      errorMessage: isInvalid ? 'error' : '',
    };

    const inputProps = value !== undefined ? { ...otherProps, value: value || '' } : otherProps;

    const input = (
      <Input
        errorMessage={showError ? errorMessage : ''}
        isInvalid={isInvalid}
        ref={ref}
        classNames={classnamesInput}
        variant="bordered"
        radius="sm"
        {...inputProps}
      />
    );

    if (maxChars === undefined) return input;

    return (
      <div className="flex w-full flex-col gap-1">
        {input}
        <CharCounter value={value} max={maxChars} min={minChars} />
      </div>
    );
  },
);

CustomInput.displayName = 'CustomInput';
